import LoggingBase from '../../../../base/loggingbase';
import Validator from '../../../../utils/Validator';

/**
 * class XtwRowItemInsertionDummyExtension - manages the "insertion dummy" appearance of a
 * row item ({@link XRowItem}): the CSS marker class and the insertion star in the row's
 * selection cell. It is a plain delegate: the host row item is passed in and accessed via
 * {@link #host}.
 */
export default class XtwRowItemInsertionDummyExtension extends LoggingBase {

	/**
	 * constructs a new instance
	 * @param {*} host the host row item (XRowItem)
	 */
	constructor( host ) {
		super( 'widgets.xtw.editing.XtwRowItemInsertionDummyExtension' );
		this._host = host;
	}

	/**
	 * @returns {*} the host row item
	 */
	get host() {
		return this._host;
	}

	/**
	 * @override
	 */
	doDestroy() {
		this._host = void 0;
		super.doDestroy();
	}

	get insertionDummy() {
		return this.host.modelItemIsValid && this.host.item.insertionDummy;
	}

	displayAsInsertionDummy() {
		this.addInsertionStar();
		const element = this.host.element;
		if ( !( element instanceof HTMLElement ) ) {
			return false;
		}
		element.classList.add( "rtp-insertion-dummy" );
		return true;
	}

	displayAsNotInsertionDummy() {
		this._removeInsertionStar();
		const element = this.host.element;
		if ( !( element instanceof HTMLElement ) ) {
			return false;
		}
		element.classList.remove( "rtp-insertion-dummy" );
		return true;
	}

	addInsertionStar() {
		return this.host.isFocused ? this._addFocusedInsertionStar() : this._addInsertionStar();
	}

	_addFocusedInsertionStar() {
		this.host._removeSelectionArrow();
		const selectionCell = this.host.selectionCell;
		if ( !Validator.is( selectionCell, "XCellItem" ) ) {
			return false;
		}
		return selectionCell.addFocusedInsertionStar();
	}

	_addInsertionStar() {
		this.host._removeSelectionArrow();
		const selectionCell = this.host.selectionCell;
		if ( !Validator.is( selectionCell, "XCellItem" ) ) {
			return false;
		}
		return selectionCell.addInsertionStar();
	}

	_removeInsertionStar() {
		const selectionCell = this.host.selectionCell;
		if ( !Validator.is( selectionCell, "XCellItem" ) ) {
			return false;
		}
		return selectionCell.removeInsertionStar();
	}

	_updateInsertionDummyFocusedUI( setToFocused ) {
		if ( !this.insertionDummy || !this.host.isRendered ) {
			return false;
		}
		this.host.element.classList.add( "rtp-insertion-dummy" );
		if ( !!setToFocused ) {
			this.host.element.classList.add( "rtp-focused" );
			return this._addFocusedInsertionStar();
		}
		this.host.element.classList.remove( "rtp-focused" );
		return this._addInsertionStar();
	}

}
